var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      staticStyle: { "max-width": "100vw", overflow: "hidden" },
      attrs: { id: "inspire" }
    },
    [
      _c(
        "v-main",
        [
          _c(
            "video-background",
            { attrs: { sources: [], img: "/static/video/background.png" } },
            [
              _c(
                "v-container",
                { attrs: { fluid: "", "fill-height": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        "justify-center": "",
                        "align-center": "",
                        column: ""
                      }
                    },
                    [_vm._t("default")],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }